module.exports = __webpack_public_path__ + "img/airbase-stage_1.4.39bfa5b7.jpg";